import React, { useEffect, useRef } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Backbone from "backbone";
import { useAppSelector, useAppDispatch } from "src/stores/redux/hooks";
import { getIsValidationErrorsSidebarOpen } from "../../helpers/selectors";
import { setShowValidationErrorsSidebarAction } from "src/stores/redux/features/flowdesigner/flowdesigner.slice";
import { loadValidationErrors } from "app/components/flow/designer/data-type-validation/validation-errors-storage";
import buildValidationErrorsView from "app/components/flow/designer/data-type-validation/errors/validation-errors";

interface ValidationErrorsSidebarProps {
    app: any;
}

const ValidationErrorsSidebar: React.FC<ValidationErrorsSidebarProps> = ({ app }) => {
    const isOpen = useAppSelector(getIsValidationErrorsSidebarOpen);
    const dispatch = useAppDispatch();
    const containerRef = useRef<HTMLDivElement>(null);
    const viewRef = useRef<any>(null);

    const handleClose = () => {
        dispatch(setShowValidationErrorsSidebarAction(false));
    };

    useEffect(() => {
        if (!isOpen || !containerRef.current || !app) return;

        const model = new Backbone.Model();
        model.app = app;

        buildValidationErrorsView(model).then(validationErrorsView => {
            if (!validationErrorsView || !containerRef.current) return;

            containerRef.current.replaceChildren(validationErrorsView.render().el);
            validationErrorsView.triggerMethod("show");
            viewRef.current = validationErrorsView;
        });

        return () => {
            if (viewRef.current) {
                viewRef.current.destroy();
                viewRef.current = null;
            }
        };
    }, [isOpen, app]);

    if (!app || !isOpen) return null;

    return (
        <Box
            sx={{
                width: 400,
                height: "100%",
                backgroundColor: "white",
                borderLeft: "1px solid #e0e0e0",
                display: "flex",
                flexDirection: "column",
                position: "relative"
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "16px",
                    borderBottom: "1px solid #e0e0e0"
                }}
            >
                <Typography variant="h6" component="h2">
                    Validation Errors
                </Typography>
                <IconButton onClick={handleClose} size="small">
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box sx={{ flex: 1, overflow: "hidden" }}>
                <div
                    ref={containerRef}
                    style={{ height: "100%", width: "100%", overflow: "hidden" }}
                />
            </Box>
        </Box>
    );
};

export default ValidationErrorsSidebar;
